/* Gesicht auf Socken – Konfigurator für Tierkissen (ohne App). Stand wie SuperHoodie 2026-10-10 (Turnstile,
   Kaufleiste am Handy), Texte auf Deutsch. Seit 2026-10-13 mit Stil-Wahl vor dem Upload (Cartoon, Comic, Aquarell,
   Pop-Art, optional Echtes Foto); jeder Stil hat eigene Versuche. Vertrag mit der Bild-API: sh-main-cushion.liquid.
   Motiv-Produkte (seit 2026-10-13): data-motiv geht als „motiv“ an den Bild-Dienst, ?stil=… wählt den Stil vor.
   Seit 2026-11-03 ohne Freigabe (Joel: „der Step muss weg“): Ist das Bild fertig, geht es direkt in den Warenkorb. */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024;
  var MIN_SIDE = 800;
  // Texte je Zustand; {stil} = Name des gewählten Stils (Cartoon, Comic, Aquarell, Pop-Art), {wer} = data-who
  // des Motivs (dein Tier, die Person, das Paar)
  var STATUS = {
    upload: 'Lade ein Foto hoch, dann zeichnen wir {wer} als {stil}.',
    generating: 'Wir zeichnen {wer} als {stil} … das dauert meist etwa 20 Sekunden.',
    result: 'Fertig – genau so drucken wir dein Kissen.',
    error: 'Beim Zeichnen ist etwas schiefgegangen.'
  };

  function formatMoney(cents, currency) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  /* Kopie des Fotos, auf max. 1024 px verkleinert, als JPEG für die Bild-API (schnellerer Upload; das Original
     geht weiter mit der Bestellung). Kann der Browser die Datei nicht lesen (z. B. HEIC), geht das Original. */
  function apiPhoto(file, url) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        try {
          var scale = Math.min(1, 1024 / Math.max(img.naturalWidth, img.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.naturalWidth * scale);
          canvas.height = Math.round(img.naturalHeight * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', 0.9);
        } catch (e) { resolve(file); }
      };
      img.onerror = function () { resolve(file); };
      img.src = url;
    });
  }

  /* Bot-Schutz (Cloudflare Turnstile), nur wenn die Section einen Site-Key hat. Jedes Cartoon bekommt ein neues
     Token; das Widget bleibt unsichtbar, solange Cloudflare keinen Klick verlangt. */
  var turnstileLoad = null;
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!turnstileLoad) {
      turnstileLoad = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = function () { window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile')); };
        s.onerror = function () { turnstileLoad = null; reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return turnstileLoad;
  }

  function base64ToBlob(b64, type) {
    var bin = atob(b64);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: type });
  }

  function init(root) {
    if (!root || root.dataset.shReady) return;
    root.dataset.shReady = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var variants = [];
    try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) { variants = []; }

    var cfg = {
      endpoint: (root.dataset.endpoint || '').trim(),
      maxTries: parseInt(root.dataset.maxTries, 10) || 3,
      demoImage: root.dataset.demoImage || '',
      cartAdd: root.dataset.cartAdd || '/cart/add.js',
      cartUrl: root.dataset.cartUrl || '/cart',
      productId: root.dataset.productId,
      currency: root.dataset.currency || 'EUR',
      sizeIndex: parseInt(root.dataset.sizeIndex, 10),
      editionIndex: parseInt(root.dataset.editionIndex, 10),
      printIndex: parseInt(root.dataset.printIndex, 10),
      turnstile: (root.dataset.turnstile || '').trim(),
      photoStyle: root.dataset.photoStyle === 'true',
      motiv: root.dataset.motiv || '',
      who: root.dataset.who || 'dein Tier',
      cut: root.dataset.cut || 'Wir schneiden dein Foto von Hand entlang der Umrisse deines Tieres aus.'
    };
    // Stil aus dem Link vorauswählen (?stil=comic, z. B. aus dem Kissen-Menü der Kopfzeile)
    (function () {
      var want = (window.location.search.match(/[?&]stil=([a-z]+)/) || [])[1];
      var tiles = $$('[data-cu-style]');
      if (!want || !tiles.some(function (b) { return b.dataset.cuStyle === want; })) return;
      tiles.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cuStyle === want ? 'true' : 'false'); });
    })();
    var startStyle = (function () {
      var on = $$('[data-cu-style]').filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      return on ? on.dataset.cuStyle : 'cartoon';
    })();
    var demo = cfg.endpoint === '';

    var el = {
      views: $$('[data-view]'),
      input: $('[data-photo-input]'),
      empty: $('[data-upload-empty]'),
      filled: $('[data-upload-filled]'),
      thumb: $('[data-photo-thumb]'),
      fileName: $('[data-file-name]'),
      change: $('[data-change-photo]'),
      photoMsg: $('[data-photo-msg]'),
      photoLarge: $('[data-photo-large]'),
      photoSmall: $('[data-photo-small]'),
      cartoon: $('[data-cartoon]'),
      versionLabel: $('[data-version-label]'),
      status: $('[data-status]'),
      resultActions: $('[data-result-actions]'),
      retry: $('[data-retry]'),
      tries: $('[data-tries]'),
      sizeBtns: $$('[data-size]'),
      sizeLabel: $('[data-size-label]'),
      editionBtns: $$('[data-edition]'),
      editionExtras: $$('[data-edition-extra]'),
      printBtns: $$('[data-print]'),
      printExtras: $$('[data-print-extra]'),
      textToggle: $('[data-text-toggle]'),
      textField: $('[data-text-field]'),
      textInput: $('[data-text-input]'),
      add: $('[data-add]'),
      addLabel: $('[data-add-label]'),
      addMsg: $('[data-add-msg]'),
      addMobile: $('[data-add-mobile]'),
      mbar: $('[data-mbar]'),
      stepUpload: $('[data-cu-step="upload"]'),
      mbarPrice: $('[data-mbar-price]'),
      price: $('[data-cu-price]'),
      was: $('[data-cu-was]'),
      wasValue: $('[data-cu-was-value]'),
      off: $('[data-cu-off]'),
      mbarMeta: $('[data-mbar-meta]'),
      nums: $$('[data-num]'),
      genTitle: $('[data-gen-title]'),
      turnstile: $('[data-turnstile-box]'),
      styleBtns: $$('[data-cu-style]'),
      stageExample: $('[data-stage-example]'),
      exampleLabel: $('[data-example-label]'),
      numStyle: $('[data-num-style]'),
      inset: $('.sh-cu-inset')
    };

    function pressedValue(btns, key) {
      if (!btns.length) return null;
      var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
      return on.dataset[key];
    }

    var state = {
      stage: 'upload',
      file: null,
      url: null,
      tries: 0,
      cartoonUrl: '',
      cartoonId: '',
      cartoonBlob: null,
      busy: false,
      size: pressedValue(el.sizeBtns, 'size'),
      edition: pressedValue(el.editionBtns, 'edition'),
      print: pressedValue(el.printBtns, 'print'),
      style: startStyle,
      byStyle: {}, // Stil → gespeichertes Ergebnis (stage, tries, cartoonUrl, cartoonId, cartoonBlob)
      errorText: ''
    };

    function styleTile(id) {
      var want = id || state.style;
      return el.styleBtns.filter(function (b) { return b.dataset.cuStyle === want; })[0];
    }
    function styleName() { var t = styleTile(); return t ? t.dataset.name : 'Cartoon'; }
    function styleNoun() { var t = styleTile(); return t ? t.dataset.noun : 'dein Motiv'; }
    function cap(text) { return text.charAt(0).toUpperCase() + text.slice(1); }
    function statusText(key) { return STATUS[key].replace('{stil}', styleName()).replace('{wer}', cfg.who); }

    // Beim Stilwechsel das bisherige Ergebnis merken und das des neuen Stils laden (jeder Stil hat eigene Versuche)
    function saveStyle() {
      if (isFoto()) return;
      state.byStyle[state.style] = { stage: state.stage, tries: state.tries, cartoonUrl: state.cartoonUrl, cartoonId: state.cartoonId, cartoonBlob: state.cartoonBlob };
    }
    function loadStyle(id) {
      var r = state.byStyle[id];
      state.stage = r && r.cartoonUrl ? 'result' : 'upload';
      state.tries = r ? r.tries : 0;
      state.cartoonUrl = r ? r.cartoonUrl : '';
      state.cartoonId = r ? r.cartoonId : '';
      state.cartoonBlob = r ? r.cartoonBlob : null;
    }

    // Stil „Echtes Foto“ (abschaltbar): kein Cartoon – die Produktion schneidet das Foto aus
    function isFoto() { return state.style === 'foto'; }
    // Bestellbar: Foto da bzw. ein gezeichnetes Bild auf der Bühne (nach einem Fehler beim Neu-Erstellen das bisherige)
    function isDone() { return isFoto() ? !!state.file : !!state.cartoonUrl && state.stage !== 'generating'; }
    function isReady() { return isDone() && !state.busy; }

    function findVariant(size, edition, print) {
      return variants.filter(function (v) {
        var okSize = isNaN(cfg.sizeIndex) || cfg.sizeIndex < 0 || v.options[cfg.sizeIndex] === size;
        var okEdition = isNaN(cfg.editionIndex) || cfg.editionIndex < 0 || v.options[cfg.editionIndex] === edition;
        var okPrint = isNaN(cfg.printIndex) || cfg.printIndex < 0 || v.options[cfg.printIndex] === print;
        return okSize && okEdition && okPrint;
      })[0] || variants[0];
    }

    function currentVariant() { return findVariant(state.size, state.edition, state.print); }

    // Aufpreis gegenüber der ersten Option der Gruppe (Ausführung oder Druck), bei sonst gleicher Auswahl
    function showExtras(btns, extras, variantFor) {
      if (btns.length < 2) return;
      var base = variantFor(btns[0]);
      btns.forEach(function (b, i) {
        var x = extras[i];
        if (!x) return;
        var other = variantFor(b);
        var diff = i > 0 && other && base ? other.price - base.price : 0;
        x.textContent = diff > 0 ? ' +' + formatMoney(diff, cfg.currency) : '';
      });
    }

    function setMsg(node, text, type) {
      if (!node) return;
      if (!text) { node.hidden = true; node.textContent = ''; return; }
      node.hidden = false;
      node.textContent = text;
      node.classList.toggle('sh-cu-msg--err', type === 'error');
      node.classList.toggle('sh-cu-msg--warn', type === 'warn');
    }

    function showView(stage) {
      var view = 'upload';
      if (stage === 'generating') view = 'generating';
      if (stage === 'result') view = 'result';
      if (stage === 'error') view = state.cartoonUrl ? 'result' : (state.url ? 'generating' : 'upload');
      el.views.forEach(function (v) { v.hidden = v.dataset.view !== view; });
      root.classList.toggle('is-error', stage === 'error');
      if (el.genTitle) el.genTitle.textContent = stage === 'error' ? 'Das hat leider nicht geklappt' : 'Wir zeichnen ' + cfg.who + ' als ' + styleName() + ' …';
    }

    function renderFoto() {
      var has = !!state.file;
      el.views.forEach(function (v) { v.hidden = v.dataset.view !== (has ? 'result' : 'upload'); });
      root.classList.remove('is-error');
      if (has && el.cartoon.getAttribute('src') !== state.url) el.cartoon.src = state.url;
      if (el.versionLabel) el.versionLabel.textContent = 'Dein Foto';
      if (el.inset) el.inset.hidden = true;
      el.resultActions.hidden = true;
      el.status.textContent = has ? cfg.cut : '';
      el.status.hidden = !has;
      if (el.nums[0]) el.nums[0].classList.toggle('is-done', has);
      el.empty.hidden = has;
      el.filled.hidden = !has;
      updatePrice();
    }

    function setImg(img, url) {
      if (!img) return;
      if (!img.dataset.example) img.dataset.example = img.getAttribute('src');
      var want = url || img.dataset.example;
      if (img.getAttribute('src') !== want) img.src = want;
    }

    function renderStyles() {
      if (!el.styleBtns.length) return;
      el.styleBtns.forEach(function (b) {
        var id = b.dataset.cuStyle;
        var on = id === state.style;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = state.busy && !on;
        var r = on ? { stage: state.stage, cartoonUrl: state.cartoonUrl } : (state.byStyle[id] || {});
        var mine = id === 'foto' ? (state.file ? state.url : '') : (r.cartoonUrl || '');
        setImg($('[data-cu-style-img="' + id + '"]'), mine);
        var ex = $('[data-cu-style-ex="' + id + '"]');
        if (ex) ex.hidden = !!mine;
        var sub = $('[data-cu-style-sub="' + id + '"]');
        if (sub) {
          var text = '';
          if (id !== 'foto' && state.file) {
            if (on && state.stage === 'generating') text = 'Wird gezeichnet …';
            else if (on && state.stage === 'error') text = 'Nicht geklappt';
            else if (r.cartoonUrl) text = 'Fertig';
          }
          sub.textContent = text;
          sub.hidden = !text;
          sub.classList.toggle('is-ok', text === 'Fertig');
        }
      });
      if (el.numStyle) el.numStyle.classList.toggle('is-done', isDone());
      // Ohne Foto: das Beispiel auf der Bühne zeigt den gewählten Stil
      if (el.stageExample) {
        if (!el.stageExample.dataset.src) {
          el.stageExample.dataset.src = el.stageExample.getAttribute('src');
          el.stageExample.dataset.srcset = el.stageExample.getAttribute('srcset') || '';
        }
        var tileImg = $('[data-cu-style-img="' + state.style + '"]');
        var useOwn = (cfg.motiv || state.style !== startStyle) && tileImg;
        var src = useOwn ? (tileImg.dataset.example || tileImg.getAttribute('src')) : el.stageExample.dataset.src;
        if (el.stageExample.getAttribute('src') !== src) {
          if (useOwn) el.stageExample.removeAttribute('srcset');
          else if (el.stageExample.dataset.srcset) el.stageExample.setAttribute('srcset', el.stageExample.dataset.srcset);
          el.stageExample.src = src;
          el.stageExample.classList.toggle('is-tile', !!useOwn);
        }
      }
      if (el.exampleLabel) el.exampleLabel.textContent = el.styleBtns.length ? 'Beispiel: ' + styleName() : 'Beispiel';
      // Motiv-Knöpfe nehmen den gewählten Stil mit
      $$('[data-cu-motif-link]').forEach(function (a) {
        a.href = a.href.split('?')[0] + (state.style !== 'cartoon' ? '?stil=' + state.style : '');
      });
    }

    // Bildleiste (2026-10-15): weitere Bilder liegen als Ebene über der Bühne. Bei jedem neuen Schritt (Foto, Zeichnen, Ergebnis,
    // Stilwechsel) springt sie zurück zur Bühne, damit man sieht, was passiert; das erste Vorschaubild zeigt, was die Bühne zeigt.
    var gal = $('[data-cu-gal]'), galImg = $('[data-cu-gal-img]'), thumbs = $$('[data-cu-thumb]'), thumbStage = $('[data-cu-thumb-stage]'), galKey = '';
    function zeigeBild(btn) {
      thumbs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      if (!gal || !galImg) return;
      if (btn.dataset.cuThumb === 'stage') { gal.hidden = true; return; }
      galImg.src = btn.dataset.cuThumb; galImg.alt = btn.dataset.cuAlt || ''; gal.hidden = false;
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { zeigeBild(b); }); });
    function galZurBuehne() {
      var key = [state.style, state.stage, state.url || '', state.cartoonUrl || ''].join('|');
      if (key !== galKey && thumbs.length) { galKey = key; zeigeBild(thumbs[0]); }
      if (!thumbStage) return;
      var src = isFoto() ? state.url : (state.cartoonUrl || (state.stage === 'generating' ? state.url : ''));
      if (!src && el.stageExample) src = el.stageExample.getAttribute('src');
      if (src && thumbStage.getAttribute('src') !== src) thumbStage.src = src;
    }

    // Vorschau fertig (2026-10-15, wie im Produkt-Konfigurator sh-configurator.js showReady/checkPreview): Ist das Bild nicht im
    // Blick, erscheint oben kurz die Pille „Deine Vorschau ist fertig – ansehen“ (einmal je Foto, Stil und gezeichnetem Bild,
    // nicht bei Größe oder Ausführung); dazu der feste Link „Auf dem Produkt ansehen“ (nur Handy, sh-cushion.css).
    var READY_MS = 8000, readyKey = '', readyUi = null, stageBox = $('[data-stage]');
    var ARROW_UP = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    function scrollToStage() {
      if (!stageBox) return;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      stageBox.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    }
    function hideReady() {
      if (!readyUi) return;
      readyUi.btn.hidden = true;
      clearTimeout(readyUi.timer);
      if (readyUi.observer) readyUi.observer.disconnect();
    }
    function showReady() {
      if (!readyUi) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'shp-ready'; b.hidden = true;
        b.innerHTML = ARROW_UP + '<span>Deine Vorschau ist fertig – ansehen</span>';
        document.body.appendChild(b);
        readyUi = { btn: b, timer: null, observer: null };
        b.addEventListener('click', function () { scrollToStage(); hideReady(); });
      }
      hideReady();
      readyUi.btn.hidden = false;
      readyUi.timer = setTimeout(hideReady, READY_MS);
      if ('IntersectionObserver' in window) {
        readyUi.observer = new IntersectionObserver(function (entries) { if (entries[0].intersectionRatio >= 0.4) hideReady(); }, { threshold: [0.4] });
        readyUi.observer.observe(stageBox);
      }
    }
    var viewLinks = {};
    [['foto', '[data-upload-filled]'], ['ki', '[data-result-actions]']].forEach(function (p) {
      var anchor = $(p[1]);
      if (!anchor) return;
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'shp-viewlink'; a.hidden = true;
      a.innerHTML = '<span>Auf dem Produkt ansehen</span>' + ARROW_UP;
      anchor.insertAdjacentElement('afterend', a);
      a.addEventListener('click', scrollToStage);
      viewLinks[p[0]] = a;
    });
    function checkReady() {
      var foto = isFoto();
      var ready = foto ? !!state.file : (state.stage === 'result' && !!state.cartoonUrl);
      if (viewLinks.foto) viewLinks.foto.hidden = !(ready && foto);
      if (viewLinks.ki) viewLinks.ki.hidden = !(ready && !foto);
      if (!ready || !stageBox) return;
      var key = [state.url || '', state.style, foto ? '' : state.cartoonUrl].join('|');
      if (key === readyKey) return;
      readyKey = key;
      var r = stageBox.getBoundingClientRect();
      var visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      if (visible < r.height * 0.4) showReady();
    }

    var note = $('[data-cu-note]');
    function render() {
      renderStyles();
      galZurBuehne();
      checkReady();
      if (note) { var nt = isFoto() ? note.dataset.foto : note.dataset.ki; if (nt && note.textContent !== nt) note.textContent = nt; }
      if (isFoto()) return renderFoto();
      if (el.inset) el.inset.hidden = false;
      if (state.cartoonUrl && el.cartoon.getAttribute('src') !== state.cartoonUrl) el.cartoon.src = state.cartoonUrl;
      var s = state.stage;
      showView(s);
      // Vor dem Upload sagt der Foto-Schritt selbst, was zu tun ist
      el.status.hidden = !state.file;
      el.status.textContent = s === 'error' ? (state.errorText || statusText('error')) : statusText(s);
      var hasResult = (s === 'result') && !!state.cartoonUrl;
      el.resultActions.hidden = !hasResult && s !== 'error';
      var left = cfg.maxTries - state.tries;
      el.retry.disabled = s === 'error' ? false : left <= 0;
      el.tries.textContent = s === 'error' ? '' : (left <= 0 ? 'Keine Versuche mehr für dieses Foto – lade ein anderes Foto hoch, um neu zu starten.' : (left === 1 ? 'Noch 1 Versuch für dieses Foto' : 'Noch ' + left + ' Versuche für dieses Foto'));
      if (el.versionLabel) el.versionLabel.textContent = cap(styleNoun()) + ' · Version ' + Math.max(1, state.tries) + (demo ? ' (Beispiel)' : '');
      if (el.nums[0]) el.nums[0].classList.toggle('is-done', isDone());
      el.empty.hidden = !!state.file;
      el.filled.hidden = !state.file;
      updatePrice();
    }

    function updatePrice() {
      var v = currentVariant();
      if (!v) return;
      var ready = isReady();
      var price = formatMoney(v.price, cfg.currency);
      el.add.disabled = !ready;
      el.add.dataset.variant = v.id;
      var drawing = !isFoto() && state.stage === 'generating';
      el.addLabel.textContent = ready ? 'In den Warenkorb · ' + price
        : drawing ? cap(styleNoun()) + ' wird gezeichnet …'
        : state.busy ? 'Wird in den Warenkorb gelegt …'
        : state.file && !isFoto() ? 'Bitte versuch es noch einmal' : 'Lade zuerst dein Foto hoch';
      if (el.addMobile) {
        // Noch nicht bereit: Der Button der Leiste führt zum Foto-Schritt, statt ausgegraut zu sein
        el.addMobile.disabled = state.busy || drawing;
        el.addMobile.textContent = ready ? 'In den Warenkorb'
          : drawing ? 'Wird gezeichnet …'
          : state.busy ? 'Wird hinzugefügt …'
          : state.file && !isFoto() ? 'Zurück zum Foto' : 'Foto hochladen';
      }
      if (el.mbarPrice) el.mbarPrice.textContent = price;
      // Preis oben mit Streichpreis und Rabatt (die Elemente gibt es nur mit der Theme-Einstellung „Streichpreise anzeigen“)
      if (el.price) el.price.textContent = price;
      var showWas = !!(v.compare_at_price && v.compare_at_price > v.price);
      if (el.was) {
        el.was.hidden = !showWas;
        if (showWas && el.wasValue) el.wasValue.textContent = formatMoney(v.compare_at_price, cfg.currency);
      }
      if (el.off) {
        el.off.hidden = !showWas;
        if (showWas) el.off.textContent = '−' + Math.floor((1 - v.price / v.compare_at_price) * 100) + ' %';
      }
      var sizeBtn = el.sizeBtns.filter(function (b) { return b.dataset.size === state.size; })[0];
      var sizeText = sizeBtn ? sizeBtn.dataset.label : '';
      if (el.sizeLabel) el.sizeLabel.textContent = sizeText;
      var meta = [sizeText];
      if (el.editionBtns.length > 1 && state.edition !== el.editionBtns[0].dataset.edition) meta.push(state.edition);
      if (state.print) meta.push(state.print);
      if (el.mbarMeta) el.mbarMeta.textContent = meta.filter(Boolean).join(' · ');
      showExtras(el.editionBtns, el.editionExtras, function (b) { return findVariant(state.size, b.dataset.edition, state.print); });
      showExtras(el.printBtns, el.printExtras, function (b) { return findVariant(state.size, state.edition, b.dataset.print); });
    }

    function clearCartoon() {
      if (state.cartoonBlob && state.cartoonUrl) { try { URL.revokeObjectURL(state.cartoonUrl); } catch (e) {} }
      state.cartoonUrl = '';
      state.cartoonId = '';
      state.cartoonBlob = null;
    }

    function setPhoto(file, url) {
      if (state.url) { try { URL.revokeObjectURL(state.url); } catch (e) {} }
      state.file = file;
      state.url = url;
      state.tries = 0;
      clearCartoon();
      // Neues Foto: Ergebnisse der anderen Stile gehören zum alten Foto
      Object.keys(state.byStyle).forEach(function (k) {
        var r = state.byStyle[k];
        if (r && r.cartoonBlob && r.cartoonUrl) { try { URL.revokeObjectURL(r.cartoonUrl); } catch (e) {} }
      });
      state.byStyle = {};
      el.fileName.textContent = file ? file.name : '';
      [el.thumb, el.photoLarge, el.photoSmall].forEach(function (img) { if (img && url) img.src = url; });
    }

    function checkFile(file) {
      return new Promise(function (resolve) {
        var isImage = /^image\//.test(file.type) || /\.(heic|heif)$/i.test(file.name);
        if (!isImage) return resolve({ ok: false, msg: 'Bitte wähle ein Foto (JPG, PNG oder HEIC).' });
        if (file.size > MAX_BYTES) return resolve({ ok: false, msg: 'Das Foto ist größer als 20 MB. Bitte wähle ein kleineres.' });
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var small = Math.min(img.naturalWidth, img.naturalHeight) < MIN_SIDE;
          resolve({ ok: true, url: url, warn: small ? 'Das Foto ist recht klein, dein Motiv wird dadurch eventuell weniger scharf. Ein größeres Foto klappt am besten.' : '' });
        };
        img.onerror = function () {
          // z. B. HEIC in Browsern, die es nicht anzeigen können – trotzdem erlaubt
          resolve({ ok: true, url: url, warn: 'Für dieses Dateiformat können wir keine Vorschau zeigen, verwenden können wir es trotzdem.' });
        };
        img.src = url;
      });
    }

    var turnstile = { id: null, pending: null };
    var TURNSTILE_ERROR = 'Wir konnten deinen Browser gerade nicht prüfen. Bitte lade die Seite neu und versuch es noch einmal.';

    function turnstileToken() {
      if (!cfg.turnstile || !el.turnstile) return Promise.resolve('');
      return loadTurnstile().then(function (ts) {
        return new Promise(function (resolve, reject) {
          var timer = setTimeout(function () { finish(new Error(TURNSTILE_ERROR)); }, 60000);
          function finish(err, token) {
            clearTimeout(timer);
            turnstile.pending = null;
            if (err) reject(err); else resolve(token);
          }
          turnstile.pending = finish;
          if (turnstile.id === null) {
            turnstile.id = ts.render(el.turnstile, {
              sitekey: cfg.turnstile,
              action: 'cartoon',
              appearance: 'interaction-only',
              execution: 'execute',
              retry: 'never',
              language: 'de',
              callback: function (token) { if (turnstile.pending) turnstile.pending(null, token); },
              'error-callback': function () { if (turnstile.pending) turnstile.pending(new Error(TURNSTILE_ERROR)); return true; },
              'expired-callback': function () {}
            });
          } else {
            ts.reset(turnstile.id);
          }
          ts.execute(turnstile.id);
        });
      }, function () {
        throw new Error(TURNSTILE_ERROR);
      });
    }

    function generate() {
      var v = currentVariant();
      if (demo) {
        return wait(2200).then(function () {
          return { image_url: cfg.demoImage, id: 'demo-' + Date.now() };
        });
      }
      return Promise.all([apiPhoto(state.file, state.url), turnstileToken()]).then(function (r) {
        var photo = r[0];
        var fd = new FormData();
        fd.append('photo', photo, photo === state.file ? state.file.name : 'photo.jpg');
        fd.append('product_id', cfg.productId);
        fd.append('stil', state.style);
        if (cfg.motiv) fd.append('motiv', cfg.motiv);
        if (v) fd.append('variant_id', v.id);
        if (r[1]) fd.append('turnstile', r[1]);
        return fetch(cfg.endpoint, { method: 'POST', body: fd });
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          var b64 = json.data && json.data[0] && json.data[0].b64_json;
          if (!res.ok || !(json.image_url || b64)) {
            throw new Error(json.error || 'Dein Cartoon konnte gerade nicht erstellt werden. Bitte versuch es noch einmal.');
          }
          if (json.image_url) return json;
          // Das Bild kommt als Daten zurück: als Datei behalten, sie geht mit der Bestellung hoch (kein eigener Speicher)
          var blob = base64ToBlob(b64, 'image/png');
          return { image_url: URL.createObjectURL(blob), blob: blob, id: '' };
        });
      });
    }

    function startGeneration() {
      if (!state.file || state.busy) return;
      if (state.tries >= cfg.maxTries) return;
      state.busy = true;
      state.stage = 'generating';
      render();
      generate().then(function (json) {
        state.tries += 1;
        clearCartoon();
        state.cartoonUrl = json.image_url;
        state.cartoonId = json.id || '';
        state.cartoonBlob = json.blob || null;
        el.cartoon.src = json.image_url;
        state.stage = 'result';
      }).catch(function (err) {
        state.errorText = (err && err.message) ? err.message : STATUS.error;
        state.stage = 'error';
      }).then(function () {
        state.busy = false;
        render();
      });
    }

    el.input.addEventListener('change', function () {
      var file = el.input.files && el.input.files[0];
      if (!file) return;
      checkFile(file).then(function (res) {
        if (!res.ok) {
          setMsg(el.photoMsg, res.msg, 'error');
          el.input.value = '';
          return;
        }
        setMsg(el.photoMsg, res.warn, res.warn ? 'warn' : null);
        setPhoto(file, res.url);
        if (isFoto()) { state.stage = 'upload'; render(); return; }
        startGeneration();
      });
    });

    el.change.addEventListener('click', function () {
      setPhoto(null, null);
      el.input.value = '';
      setMsg(el.photoMsg, '');
      state.stage = 'upload';
      render();
      el.input.click();
    });

    el.retry.addEventListener('click', function () {
      if (state.stage === 'error') {
        state.stage = state.cartoonUrl ? 'result' : 'upload';
        // neuer Anlauf, ohne einen Versuch zu verbrauchen
        startGeneration();
        return;
      }
      startGeneration();
    });

    el.sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.size = btn.dataset.size;
        el.sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updatePrice();
      });
    });

    el.editionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.edition = btn.dataset.edition;
        el.editionBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updatePrice();
      });
    });

    el.printBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.print = btn.dataset.print;
        el.printBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updatePrice();
      });
    });

    el.styleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.cuStyle;
        if (id === state.style || state.busy) return;
        saveStyle();
        state.style = id;
        if (!isFoto()) loadStyle(id);
        // Foto schon da, aber in diesem Stil noch nichts gezeichnet: jetzt zeichnen
        if (!isFoto() && state.file && !state.cartoonUrl) { state.stage = 'upload'; startGeneration(); return; }
        render();
      });
    });

    if (el.textToggle) {
      el.textToggle.addEventListener('change', function () {
        el.textField.hidden = !el.textToggle.checked;
        if (el.textToggle.checked) el.textInput.focus();
      });
    }

    function addToBasket() {
      if (!isReady()) return;
      var v = currentVariant();
      if (!v) return;
      state.busy = true;
      setMsg(el.addMsg, '');
      updatePrice();
      // Properties: „Foto“ (Original), „Stil“, „Gezeichnetes Bild“ (PNG = Druckdatei), „_cartoon_id“, „Name oder Text“.
      // Die Foto-Übergabe (services/order-files) legt beim Kissen nur das gezeichnete Bild in Dropbox ab.
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      if (state.file) fd.append('properties[Foto]', state.file, state.file.name);
      // Gezeichnet: „Stil“ und „Gezeichnetes Bild“ (PNG = Druckdatei, Foto-Übergabe legt es als _Cartoon ab)
      fd.append('properties[Stil]', isFoto() ? 'Echtes Foto' : styleName());
      if (isFoto()) { /* nur das Foto */ }
      else if (demo) fd.append('properties[Gezeichnetes Bild]', 'DEMO – nicht erstellt');
      else if (state.cartoonBlob) fd.append('properties[Gezeichnetes Bild]', state.cartoonBlob, state.style + '.png');
      else fd.append('properties[Gezeichnetes Bild]', state.cartoonUrl);
      if (state.cartoonId && !isFoto()) fd.append('properties[_cartoon_id]', state.cartoonId);
      var text = el.textToggle && el.textToggle.checked && el.textInput ? el.textInput.value.trim() : '';
      if (text) fd.append('properties[Name oder Text]', text.slice(0, 20));
      fetch(cfg.cartAdd, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) {
            if (!res.ok || json.status) throw new Error(json.description || json.message || 'Das Kissen konnte gerade nicht in den Warenkorb gelegt werden. Bitte versuch es noch einmal.');
            return (window.shAddedToCart ? window.shAddedToCart() : Promise.resolve()).then(function () {
              window.location.href = cfg.cartUrl;
            });
          });
        })
        .catch(function (err) {
          state.busy = false;
          setMsg(el.addMsg, err.message, 'error');
          updatePrice();
        });
    }

    el.add.addEventListener('click', addToBasket);
    if (el.addMobile) {
      el.addMobile.addEventListener('click', function () {
        if (isReady()) return addToBasket();
        if (el.stepUpload) el.stepUpload.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Kaufleiste am Handy: nur solange der Hauptbutton noch unterhalb des Bildschirms liegt
    if (el.mbar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        el.mbar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top > 0);
      }).observe(el.add);
    }

    if (cfg.turnstile && !demo) loadTurnstile().catch(function () {});
    render();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sh-cushion]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
